import { MouseCursorIcon, PlusOutlineIcon } from '@carboncopyco/icons';
import type { TourFrame } from '@carboncopyco/types';
import { ColorHex, TextBase } from '@carboncopyco/ui';
import classNames from 'classnames';
import { useTourEditorPageProps } from '../../../../TourEditorPageContext';
import type { ReplayerEditorRef } from '../../../../ToursReplayerEditor';
import { IconWrapper } from '../IconWrapper';
import useAddStepActions from './useAddStepActions';

interface IAddStep {
  isAddingStep: boolean;
  isStepDisabled: boolean;
  frame: TourFrame;
  replayerRef: React.RefObject<ReplayerEditorRef>;
}

export const AddStep = ({
  isAddingStep,
  isStepDisabled,
  frame,
  replayerRef,
}: IAddStep) => {
  const { uuid } = useTourEditorPageProps();

  const { handleAddingStep } = useAddStepActions({
    uuid,
    frameId: frame.id,
    tourId: frame.tourData.id,
    replayerRef,
  });

  const handleOnClick = () => {
    handleAddingStep(frame);
  };

  return (
    <div
      className={classNames(
        `my-1 w-full h-[42px] border rounded-md flex items-center py-3 px-2.5 
        font-sm gap-2.5 text-ds-primary-300 cursor-pointer `,
        {
          'border-dashed border-ds-natural-200 ': !isAddingStep,
        },
        {
          'bg-white border-solid  border-ds-primary-300  hover:border-ds-primary-300 drop-shadow-[0_0_1.5px_#0078EF]':
            isAddingStep && !isStepDisabled,
          'bg-white hover:border-ds-natural-300  hover:border-dashed ':
            !isAddingStep && !isStepDisabled,
        }
      )}
      onClick={
        isStepDisabled
          ? undefined
          : (event) => {
              event.stopPropagation();
              handleOnClick();
            }
      }
    >
      <IconWrapper size="sm">
        {isAddingStep ? (
          <MouseCursorIcon size={20} />
        ) : (
          <PlusOutlineIcon
            size={20}
            color={isStepDisabled ? ColorHex.natural200 : ColorHex.primary300}
          />
        )}
      </IconWrapper>
      <TextBase
        label={isAddingStep ? 'Select target element' : 'Add step'}
        color={isStepDisabled ? 'text-ds-natural-200' : 'text-ds-primary-300'}
        ellipsis
      />
    </div>
  );
};
